import { useEffect, useState } from 'react';
import axios from 'axios';

export default function H2hModal({payout}) {
  const [h2hOrders, setH2hOrders] = useState([]);
  const maxPayout = $('#max-payout').val();
  useEffect(() => {

    const loggedIn = document.body.classList.contains('logged-in');
    if (!loggedIn) {
      return;
    }

    async function fetchH2hOrders() {
      try {
        const response = await axios.get('/wp-admin/admin-ajax.php?action=get_available_h2h_orders');
        if (response.data.success) {
          setH2hOrders(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching H2H orders:', error);
      }
    }

    fetchH2hOrders();
  }, []);

  return (
    <div className="modal fade mt-5" id="h2h-modal" tabIndex={-1} role="dialog" aria-labelledby="Head to Head details" aria-hidden="true">
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header text-center">
            <div className="w-100"><h2 className="modal-title">Head-to-Head</h2></div>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div style={{fontSize: 40}}>👥</div>
            <h2>Head-to-Head Mode Active</h2>
            { payout > 99 && (<p>Payouts over ${maxPayout} are played as Head-to-Head.</p>)}
            <h3>50/50 chance to Win!</h3>
            <p>Once your entry is placed, you can await an opponent <br/>or invite a friend to join.</p>
            <button className="mt-3 btn btn-outline-danger w-100" data-dismiss="modal" aria-label="Close">Great, let's play!</button>

           { h2hOrders.length > 0 && (
            <div className="mt-4">
              <h4>Available Opponents:</h4>
              <div>
                {h2hOrders.map((order, index) => (
                  <div key={index}>
                    <a className="text-danger" href={`/board/?h2h=${order.order_id}`}>{order.player_name} - Wager: ${order.wager} - Payout: ${order.h2h_payout}</a>
                  </div>
                ))}
              </div>
            </div>
          )}
          </div>
        </div>
      </div>
    </div>
  )
}